import { render, staticRenderFns } from "./MadeUpView.vue?vue&type=template&id=27af2a2c&scoped=true"
import script from "./MadeUpView.vue?vue&type=script&lang=js"
export * from "./MadeUpView.vue?vue&type=script&lang=js"
import style0 from "./MadeUpView.vue?vue&type=style&index=0&id=27af2a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27af2a2c",
  null
  
)

export default component.exports